import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { RankingDTO } from "../../schema/Gamification/Ranking/RankingDTO";
import { RankingFiltersDTO } from "../../schema/Gamification/Ranking/RankingFiltersDTO";

@Injectable({
    providedIn: "root"
})
export class ApiRankingService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.gamification.url}/api/v1/rankings`;
    }

    list(filter: RankingFiltersDTO): Observable<GetDataDTO<RankingDTO>> {
        let params = new HttpParams()
            .set("skip", filter.skip.toString())
            .set("take", filter.take.toString())
            .set("sortOrder", filter.sortOrder.toString())
            .set("orderBy", filter.orderBy.toString());

        if (filter.find != null) params = params.set("find", filter.find);
        if (filter.valids != null) params = params.set("valids", filter.valids.toString());
        if (filter.active != null) params = params.set("active", filter.active.toString());
        if (filter.isDefault != null) params = params.set("isDefault", filter.isDefault.toString());

        return this.httpClient.get<GetDataDTO<RankingDTO>>(`${this.relativePath}`, { params: params });
    }

    Get(id: string): Observable<RankingDTO> {
        return this.httpClient.get<RankingDTO>(`${this.relativePath}/${id}`);
    }
}
